import * as React from "react";
import { MetaTags } from "../../../head";

const Order = () => [
  <MetaTags key={0} title="Quy định &amp; Quy trình giao dịch" />,
  <div key={1} className="tab-pane active">
    <h1>Quy định &amp; Quy trình giao dịch của Express Design</h1>
    <p>
      <a href="http://expressdesign.vn">www.expressdesign.vn</a> là website đặt
      hàng thiết kế trực tuyến phục vụ cho các cá nhân, doanh nghiệp, bất kỳ ai
      có nhu cầu thiết kế các ấn phẩm/sản phẩm truyền thông, quảng cáo, bán
      hàng, nhận diện thương hiệu, sản phẩm, dựng video… bằng cách áp dụng
      thương mại điện tử vào trong thiết kế, việc đặt hàng thiết kế trở nên dễ
      dàng hơn vì bạn chỉ cần thao tác trên website của chúng tôi. Ngay khi bạn
      gửi yêu cầu, Express Design thiết kế ngay lập tức, đặc biệt bạn có thể
      nhận sản phẩm thiết kế chỉ sau vài giờ.
    </p>

    <h3>Quy trình giao dịch trên ExpressDesign.vn</h3>
    <h4>1. Gửi yêu cầu trực tuyến</h4>
    <p>
      Truy cập www.expressdesign.vn và nhập các thông tin về sản phẩm mà bạn
      đang cần thiết kế.
    </p>

    <h4>2. Xác nhận thông tin và chi phí</h4>
    <p>
      Đội ngũ Chăm sóc Khách hàng của chúng tôi sẽ gọi điện cho bạn ngay sau khi
      bạn đặt hàng để hiểu hơn về nhu cầu của bạn, tư vấn cho bạn có một sản
      phẩm thiết kế tốt nhất, xác nhận thời gian thiết kế và chi phí phù hợp với
      bạn.
    </p>
    <p>
      bạn có thể xem chi tiết về số lượng mẫu thiết kế mặc định mà chúng tôi sẽ
      thiết kế cho bạn và các quy định thiết kế khác qua Quy định thiết kế của
      chúng tôi.
    </p>
    <p>
      Với một số sản phẩm đặc thù và chúng tôi cần rất nhiều nhân lực để thực
      hiện sản phẩm thiết kế đó, chúng tôi có thể yêu cầu bạn thanh toán trước
      50%. bạn có thể xem chi tiết về danh mục các sản phẩm cần thanh toán trước
      ở bên dưới.
    </p>

    <h4>3. Thiết kế</h4>
    <p>
      Ngay sau khi bạn xác nhận thông tin, Express thiết kế ngay lập tức, giúp
      bạn có một sản phẩm sáng tạo và phù hợp với nhu cầu.
    </p>
    <p>
      Với các trường hợp thanh toán trước, chúng tôi có thể yêu cầu bạn thanh
      toán và chúng tôi xác nhận đã thanh toán thành công thì công việc thiết kế
      mới được thực hiện.
    </p>
    <h4>4. Giao sản phẩm</h4>
    <p>
      Với thời gian giao sản phẩm đã xác định trước, chúng tôi sẽ gửi cho bạn
      sản phẩm thiết kế thông qua tài khoản cá nhân của bạn tại Express Design
      và một thông báo qua email của bạn.
    </p>
    <h4>5. Đánh giá và chỉnh sửa</h4>
    <p>
      bạn có thể đánh giá sản phẩm và yêu cầu sửa mẫu thiết kế bằng cách gửi
      phản hồi thông qua tài khoản Express Design, email
      <a href="mailto:support@expressdesign.vn">support@expressdesign.vn</a> hay
      liên hệ trực tiếp với Trung tâm Chăm sóc khách hàng của chúng tôi.
    </p>
    <p>
      Chúng tôi không giới hạn số lần chỉnh sửa và bạn sẽ không mất phí cho các
      lần chỉnh sửa đó. Tuy nhiên, bạn cũng nên cân nhắc các quyết định chỉnh
      sửa để số lượng chỉnh sửa là thấp nhất thì sản phẩm thiết kế sẽ là tốt
      nhất.
    </p>
    <h4>6. Thanh toán và nhận sản phẩm gốc </h4>
    <p>
      Khi chúng tôi giao sản phẩm cho bạn, chúng tôi có thể cung cấp sản phẩm
      với kích thước nhỏ hơn hoặc gắn biểu tượng thương hiệu của chúng tôi hoặc
      bạn không thể tải xuống sản phẩm đó. Ngay sau khi chúng tôi xác nhận bạn
      đã thanh toán chi phí, chúng tôi sẽ mở khóa để bạn có thể tải sản phẩm với
      chất lượng cao.
    </p>

    <h3>Thanh toán và Quy định thanh toán</h3>
    <p>
      Đối với khách hàng không có nhu cầu hoá đơn có VAT, Quý khách có thể
      chuyển khoản trực tiếp cho chúng tôi theo danh sách Ngân hàng dưới đây:
    </p>

    <p>Nội dung chuyển khoản: Họ tên_thanh toán #mã đơn hàng</p>

    <p>
      Đối với khách hàng có nhu cầu thanh toán hoá đơn có VAT, Quý khách bắt
      buộc phải chuyển khoản qua các tài khoản sau: <br />
      Tên TK: Công ty TNHH Express Design <br />
      STK: <br />
      Ngân hàng: <br />
    </p>
    <p>Nội dung chuyển khoản: Họ tên_thanh toán #mã đơn hàng</p>

    <p>
      <b>Quy định:</b>
    </p>
    <p>
      Khi bạn đặt hàng thành công Dịch vụ của Express Design, bạn đã đồng ý với
      các quy định thanh toán của chúng tôi. Chúng tôi có thể điều chỉnh quy
      định thanh toán và thông báo cho bạn thông qua email bạn đã chia sẻ cho
      chúng tôi.
    </p>
    <p>
      Để đảm bảo chi phí vận hành, Express Design khuyến khích khách hàng thanh
      toán trước khi nhận sản phẩm thiết kế. Với các trường hợp thanh toán
      trước, chúng tôi dành nhiều ưu đãi và ưu tiên hơn so với các đơn hàng chưa
      thanh toán nếu đơn hàng đó không phải là đơn hàng “thiết kế hoả tốc". Cụ
      thể như sau:
    </p>

    <ul>
      <li>
        Đối với trường hợp thanh toán trước 50%: bạn được giảm giá theo quy định
        của Express Design (Chúng tôi công khai con số ưu đãi trong khi bạn đang
        đặt hàng trực tuyến trên website). Sản phẩm được giao sẽ khoá tự động
        tính năng tải xuống sản phẩm. Tính năng này sẽ được mở khi bạn thanh
        toán 50% chi phí còn lại.
      </li>
      <li>
        Đối với trường hợp thanh toán trước 100%: bạn được giảm giá theo quy
        định của Express Design (Chúng tôi công khai con số ưu đãi trong khi bạn
        đang đặt hàng trực tuyến trên website). Khi giao sản phẩm, tính năng tải
        xuống sản phẩm thiết kế sẽ luôn luôn được mở để bạn có thể tải xuống bất
        kỳ mẫu sản phẩm nào.
      </li>
      <li>
        Đối với trường hợp không thanh toán trước: bạn sẽ không nhận được ưu đãi
        giảm giá và tính năng tải xuống sản phẩm thiết kế sẽ bị khoá cho đến khi
        bạn thanh toán 100% chi phí.
      </li>
      <li>
        Đối với trường hợp yêu cầu thiết kế hoả tốc: Thiết kế hoả tốc có nghĩa
        là bạn yêu cầu chúng tôi thiết kế nhanh hơn số thời lượng thiết kế mặc
        định của chúng tôi. Lúc đó, bạn sẽ phải thanh toán trước 50% và hiển
        nhiên bạn sẽ được nhận ưu đãi và quy định như trong trường hợp thanh
        toán 50%. bạn cũng có thể lựa chọn thanh toán trước 100% và nhận các ưu
        đãi như trong quy định của trường hợp thanh toán trước 100%.
      </li>
      <li>
        Đối với trường hợp yêu cầu thiết kế đặc biệt như: vẽ tay, đồ lại hình
        ảnh, thiết kế lại theo mẫu ảnh… chúng tôi cần bạn thanh toán trước 50%
        và hiển nhiên bạn sẽ được nhận ưu đãi và quy định như trong trường hợp
        thanh toán 50%. bạn cũng có thể lựa chọn thanh toán trước 100% và nhận
        các ưu đãi như trong quy định của trường hợp thanh toán trước 100%.
      </li>
    </ul>
  </div>,
];

export default Order;



// WEBPACK FOOTER //
// ./src/routes/StaticPages/components/Order.tsx